// Angular
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// Lodash
import _cloneDeep from 'lodash-es/cloneDeep';
// Quill
import * as Quill from "quill";

import "quill/dist/quill.core.css?global";
import "quill/dist/quill.snow.css?global";
// Afidium
import { GenericField, IGenericField } from '../generic-field';
import { IFieldSpecs } from '../interfaces/field-specs';
import { Yii } from "libraries/interfaces/Yii";

// Primeng needs the dependency to be set to a global variable
declare const window: any;
window.Quill = Quill;

declare const permissions: IPermission;

interface IPermission {
    textEditor: IEditorPermissions;
}

interface IEditorPermissions {
    bold?: IEditorPermission;
    italic?: IEditorPermission;
    underline?: IEditorPermission;
    link?: IEditorPermission;
    ul?: IEditorPermission;
    ol?: IEditorPermission;
    color?: IEditorPermission;
}

interface IEditorPermission {
    use: boolean;
}

interface IToolbarButtonDefinition {
    type?: string;
    title: string;
    key: string;
    value?: string;
    permission: string;
}

/**
 * @deprecated
 */
@Component({
    selector: 'rich-textarea-field',
    templateUrl: './rich-textarea-field.component.html',
    styleUrls: ['../common.scss'],

})
export class RichTextareaFieldComponent extends GenericField implements IGenericField, OnInit {

    private static possibleButtons: IToolbarButtonDefinition[] = [
        { key: 'bold', title: Yii.t('wui-shared-js', 'Gras'), permission: 'bold' },
        { key: 'italic', title: Yii.t('wui-shared-js', 'Italique'), permission: 'italic' },
        { key: 'underline', title: Yii.t('wui-shared-js', 'Souligné'), permission: 'underline' },
        { key: 'link',title: Yii.t('wui-shared-js', 'Lien hypertexte'), permission: 'link' },
        { key: 'list', value: "bullet", title: Yii.t('wui-shared-js', 'Puces'), permission: 'ul' },
        { key: 'list', value: "ordered", title: Yii.t('wui-shared-js', 'Numérotation'), permission: 'ol' },
        { type: 'select', key: 'color', title: Yii.t('wui-shared-js', 'Couleur'), permission: 'color' },
    ];

    @Input()
    public fieldConfig: IFieldSpecs;

    @Input()
    public forceLinkPermission: boolean;

    @Output()
    public readonly onTextChange: EventEmitter<object> = new EventEmitter<object>();

    public buttons: IToolbarButtonDefinition[] = [];

    public ngOnInit(): void {
        this.buttons = typeof permissions !== 'undefined'
            ? this.getPossibleButtons(RichTextareaFieldComponent.possibleButtons)
            : RichTextareaFieldComponent.possibleButtons;
    }

    private getPossibleButtons(possibleButtons: IToolbarButtonDefinition[]): IToolbarButtonDefinition[] {
        const myPermissions: IPermission = _cloneDeep(permissions);
        if (this.forceLinkPermission) {
            myPermissions.textEditor.link = {use: true};
        }
        return possibleButtons
            .filter(({ permission }) =>
                myPermissions &&
                myPermissions.textEditor &&
                myPermissions.textEditor[permission] &&
                myPermissions.textEditor[permission].use
            );
    }
}
